import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/ball.svg'
import _imports_1 from './assets/images/fluent_receipt.png'


const _withScopeId = n => (_pushScopeId("data-v-6552c9d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-block" }
const _hoisted_2 = { class: "contract-items" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Contract Items", -1))
const _hoisted_4 = { class: "p-d-flex p-justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign Type", -1))
const _hoisted_6 = { class: "p-d-flex p-justify-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Android CPI", -1))
const _hoisted_8 = { class: "p-d-flex p-justify-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "IOS CPI", -1))
const _hoisted_10 = { class: "p-mt-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Payment summary", -1))
const _hoisted_12 = { class: "p-d-flex p-justify-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Transaction fees", -1))
const _hoisted_14 = { class: "p-d-flex p-justify-between" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Total Amount", -1))
const _hoisted_16 = { style: {"font-size":"14px"} }
const _hoisted_17 = { class: "agreement p-mb-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agreements",
  class: "p-ml-2"
}, "I require an invoice for this payment", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cut p-mt-5" }, null, -1))
const _hoisted_20 = { class: "p-mt-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Payment total", -1))
const _hoisted_22 = { class: "p-d-flex p-justify-between" }
const _hoisted_23 = { class: "p-d-flex" }
const _hoisted_24 = { class: "p-mr-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mr-4 logo-blc" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "ball"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "ball-file"
  })
], -1))
const _hoisted_26 = { class: "agreement" }
const _hoisted_27 = {
  for: "agreement",
  class: "p-ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Terms = _resolveComponent("Terms")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString($props.campaign?.targetMarket?.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString($props.newBudgetData?.cpi?.android?.amount) + " " + _toDisplayString($props.newBudgetData?.cpi?.android?.currency), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString($props.newBudgetData?.cpi?.ios?.amount) + " " + _toDisplayString($props.newBudgetData?.cpi?.ios?.currency), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString($props.campaign?.budget?.amount === $props.newBudgetData.budget?.amount ? $props.newBudgetData.budget?.amount / 100 * $setup.fees :
              (($props.newBudgetData.budget?.amount - $props.campaign?.budget?.amount) / 100) * $setup.fees) + " USD", 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString($props.campaign?.budget?.amount === $props.newBudgetData.budget?.amount ? $props.newBudgetData.budget?.amount :
              $props.newBudgetData.budget?.amount - $props.campaign?.budget?.amount) + " USD", 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_Checkbox, {
            id: "agreements",
            modelValue: $setup.requireInvoice,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.requireInvoice) = $event)),
            binary: true,
            class: "p-mt-4"
          }, null, 8, ["modelValue"]),
          _hoisted_18
        ])
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h1", _hoisted_24, _toDisplayString($props.campaign?.budget?.amount === $props.newBudgetData.budget?.amount ? $props.newBudgetData.budget?.amount + $props.newBudgetData.budget?.amount / 100 * $setup.fees
                    : ((($props.newBudgetData.budget?.amount - $props.campaign?.budget.amount) / 100) * $setup.fees)
                    + $props.newBudgetData.budget?.amount - $props.campaign?.budget?.amount), 1),
            _createElementVNode("h4", null, _toDisplayString($props.campaign?.budget?.currency), 1)
          ]),
          _hoisted_25
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_Checkbox, {
        id: "agreement",
        modelValue: $setup.acceptedTerms,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.acceptedTerms) = $event)),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('agreeTerms', $setup.acceptedTerms))),
        binary: true,
        class: "p-mt-4"
      }, null, 8, ["modelValue"]),
      _createElementVNode("label", _hoisted_27, [
        _createTextVNode(" I agree with the "),
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showTerms = !$setup.showTerms))
        }, "Terms And Conditions"),
        _createTextVNode(" of Gameinfluencer")
      ])
    ]),
    _createVNode(_component_Terms, {
      onCloseTerms: _cache[4] || (_cache[4] = ($event: any) => ($setup.showTerms = !$setup.showTerms)),
      "show-modal": $setup.showTerms
    }, null, 8, ["show-modal"])
  ]))
}